import React from 'react';
import WorkerAnt from './images/WorkForce.png';
import FighterAnt from './images/WorkForce.png';
import WiseAnt from './images/WorkForce.png';
import BackButton from './BackButton';
import { useNft } from '../contexts/NftContext.js'; // Adjust the path as necessary
import Tooltip from './Tooltip.js';

function AntStats() {
  const { activeNft, isLoading } = useNft();

  const formatAddress = (address) => {
    if (!address) return '';
    return `${address.substring(0, 6)}...${address.substring(address.length - 6)}`;
  };

  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      // Optional: Display a message or visual feedback
      alert('Address copied to clipboard!');
    }, (err) => {
      console.error('Error copying text to clipboard', err);
    });
  };

  return (
    <div className="left-content">
      <div className={`Ant-class`}>
        <h1>Worker ANT</h1>
        <div className="class-image">
          <img src={WorkerAnt} alt="Worker ANT" />
        </div>
      </div>
      <h3 onClick={() => copyToClipboard(activeNft.activeTokenAddress)} style={{ cursor: 'pointer' }}>
        {formatAddress(activeNft.activeTokenAddress)}
      </h3>
      <div className="level-container">
        <div className="level">
          <h2>{isLoading ? 'Loading...' : activeNft.level || 'N/A'}</h2> 
        </div>
        <div className="experience">
          <h2>{isLoading ? 'Loading...' : activeNft.level === 40 ? 'MAX' : `${activeNft.remainPotions || 0} / ${activeNft.level + 1}`}</h2> 
          <Tooltip text="Ant's level and experience"></Tooltip>
        </div>
      </div>
      <div className="divider" id="stats-divider"></div>
    </div>
  );
}

export default AntStats;